import { Configuration, CreateGenericPayerDto, CreateOneTimePaymentDto, FeesDTO, PaymentsApi, TransactionDTO, UpdateGenericPayerDto, UserRegistrationResponse } from "@inosio/payments-sdk";
import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { FeeParamsDto } from "../../../pmui/paymentrequests/sagas/paymentrequestslice";
import { createGenericPayer, updateGenericPayer, setGenericPayerResponse, handleGenericPayerFailed, getQuickPaymentFees, setQuickPaymentFees, getQuickPaymentFeesFailed, GenericPayerResponseDto, selectGenericPayerResponse, getMakeQuickPayOtp, setMakeQuickPayOtp, setMakeQuickPayOtpError } from "./quickpaymentsSlice";

const { REACT_APP_IPA_BASE_PATH } = process.env;
const apiConfig = new Configuration({ basePath: REACT_APP_IPA_BASE_PATH });

export function requestCreateGenericPayer(createGenericPayerDto: CreateGenericPayerDto) {
  const ipaApplicationsAPI = new PaymentsApi(apiConfig);
  return ipaApplicationsAPI.createGenericPayer(createGenericPayerDto);
}

export function requestUpdateGenericPayer(payerUuid: string, updateGenericPayerDto: UpdateGenericPayerDto) {
  const ipaApplicationsAPI = new PaymentsApi(apiConfig);
  return ipaApplicationsAPI.updateGenericPayer(payerUuid, updateGenericPayerDto);
}

export function requestGetQuickPaymentFees(feeParams: FeeParamsDto) {
  const ipaPaymentsAPI = new PaymentsApi(apiConfig);
  return ipaPaymentsAPI.getPaymentFees(feeParams.PayerUUID, feeParams.PaymentAmount, feeParams.PropPayTypeId)
}

export function requestMakeQuickPayOtpDto(createOneTimePaymentDto: CreateOneTimePaymentDto) {
  const ipaPaymentsAPI = new PaymentsApi(apiConfig);
  return ipaPaymentsAPI.createOneTimePayment(createOneTimePaymentDto);
}

export function* handleCreateGenericPayer(action: any) {
  try {
    const response: AxiosResponse<UserRegistrationResponse> = yield call(requestCreateGenericPayer, action.payload);
    const { data } = response;
    yield put(setGenericPayerResponse(data));
  } catch (error: any) {
    yield put(
      handleGenericPayerFailed({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode,
      })
    );
  }
}

export function* handleUpdateGenericPayer(action: any) {
  try {
    const genericPayer: GenericPayerResponseDto = yield select(selectGenericPayerResponse);
    const updateDto = {
      ...action.payload,
      access_token: genericPayer.accessToken,
    } as UpdateGenericPayerDto;
    
    const response: AxiosResponse<UserRegistrationResponse> = yield call(requestUpdateGenericPayer, action.payload.Uuid, updateDto);
    const { data } = response;
    yield put(setGenericPayerResponse(data));
  } catch (error: any) {
    yield put(
      handleGenericPayerFailed({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode,
      })
    );
  }
}

export function* handleGetQuickPaymentFees(action: any) {
  try {
    const response: AxiosResponse<FeesDTO> = yield call(
      requestGetQuickPaymentFees,
      action.payload
    );
    const { data } = response;
    yield put(setQuickPaymentFees(data));
  } catch (error: any) {
    getQuickPaymentFeesFailed({
      message: error?.response?.data?.message,
      statusCode: error?.response?.data?.statusCode,
    })
  }
}

export function* handleMakeQuickPayOtpDto(action: {
  type: typeof getMakeQuickPayOtp,
  payload: CreateOneTimePaymentDto
}) {
  try {
    const response: AxiosResponse<TransactionDTO> = yield call(
      requestMakeQuickPayOtpDto,
      action.payload
    );
    const { data } = response;
    yield put(setMakeQuickPayOtp(data));
  } catch (error: any) {
    if (error?.response?.data) {
      yield put(setMakeQuickPayOtpError({ message: error?.response?.data?.message }));
    } else {
      yield put(setMakeQuickPayOtpError({ ...error }))
    }
  }
}

export function* quickPaymentsSaga() {
  yield takeLatest(createGenericPayer.type, handleCreateGenericPayer);
  yield takeLatest(updateGenericPayer.type, handleUpdateGenericPayer);
  yield takeLatest(getQuickPaymentFees.type, handleGetQuickPaymentFees);
  yield takeLatest(getMakeQuickPayOtp.type, handleMakeQuickPayOtpDto);
}
